import PageHeading from "./PageHeading";
import { Parallax } from "react-scroll-parallax";
import { useContext } from "react";
import "../../../css/azienda.css";
import useFetch from "../../../hooks/useFetch";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import LanguageContext from "../../../context/language-context";
import { useParams } from "react-router-dom";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Popup from "../../UI/Popup";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <SlArrowRight />
    </div>
  );
}
function SamplePreviousArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <SlArrowLeft />
    </div>
  );
}

export default function BrandInner() {
  const { slug } = useParams(); // Get the slug from the URL params
  var settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 3,
    speed: 500,
    // autoplay: true,
    // autoplaySpeed: 2000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePreviousArrow />,
  };
  const languageCtx = useContext(LanguageContext); // Get the current language context
  const { loading, error, data } = useFetch(
    `https://spagnoladmin.spagnolcompany.it/api/brands?locale=${languageCtx.languageData}&populate[0]=Brand.Image&populate[1]=Brand.Innerpage_details&populate[2]=Brand.Inner_Section&populate[3]=Brand.Inner_Section.Image&populate[4]=Brand.Inner_Section.Images&populate[5]=Brand.Innerpage_details.Banner_Image&populate[6]=Brand.Popup.Icon`
  );

  if (loading) {
    return <p>Loading...</p>; // Display loading message while data is being fetched
  }

  const { data: details, meta } = data;
  const selectedProducts = details[0].attributes.Brand.find(
    (item) => item.Heading.toLowerCase() === slug
  );

  // Empty dependency array to run only once on mount

  return (
    <div className="">
      <PageHeading
        img={
          selectedProducts.Innerpage_details[0].Banner_Image.data.attributes.url
        }
      />
      <div className="mission-text" data-scroll-section>
        <Parallax speed={4}>
          <BlocksRenderer
            content={selectedProducts.Innerpage_details[0].About}
            blocks={{
              paragraph: ({ children }) => (
                <p className="mt-4 text-base lg:text-xl">{children}</p>
              ),
              heading: ({ children, level }) => {
                const Tag = `h${level}`;
                return (
                  <Tag className="mt-4 font-bold text-base lg:text-2xl">
                    {children}
                  </Tag>
                );
              },
              list: ({ children, format }) =>
                format === "unordered" ? (
                  <ul className="list-disc list-inside ml-6 mt-4">
                    {children}
                  </ul>
                ) : (
                  <ol className="list-decimal list-inside ml-6 mt-4">
                    {children}
                  </ol>
                ),
              quote: ({ children }) => (
                <blockquote className="border-l-4 border-gray-300 pl-4 font-extrabold text-2xl text-black mt-4 w-[80%]">
                  {children}
                </blockquote>
              ),
              link: ({ children, url }) => (
                <Link to={url} className="text-footer underline">
                  {children}
                </Link>
              ),
              image: ({ image }) => (
                <img
                  src={image.url}
                  alt={image.alternativeText || ""}
                  className="img-100"
                />
              ),
            }}
          />
        </Parallax>
      </div>
      {selectedProducts.Inner_Section.map((item, index) => (
        <Parallax speed={4} key={index}>
          <div className="brand-image">
            <div className="first-section">
              <div
                className={`section-inner fullscreen brands  ${
                  (index + 1) % 2 === 0 ? "row-reverse" : ""
                }
              }`} // Set the index as a data attribute for reference/ Assign ref to each section
              >
                <div className="left-text ft2">
                  <Parallax speed={3}>
                    <BlocksRenderer
                      content={item.Description}
                      blocks={{
                        paragraph: ({ children }) => (
                          <p className="mt-4 text-base lg:text-xl">
                            {children}
                          </p>
                        ),
                        heading: ({ children, level }) => {
                          const Tag = `h${level}`;
                          return (
                            <Tag className="mt-4 font-bold text-base lg:text-2xl">
                              {children}
                            </Tag>
                          );
                        },
                        list: ({ children, format }) =>
                          format === "unordered" ? (
                            <ul className="list-disc list-inside ml-6 mt-4">
                              {children}
                            </ul>
                          ) : (
                            <ol className="list-decimal list-inside ml-6 mt-4">
                              {children}
                            </ol>
                          ),
                        quote: ({ children }) => (
                          <blockquote className="border-l-4 border-gray-300 pl-4 font-extrabold text-2xl text-black mt-4 w-[80%]">
                            {children}
                          </blockquote>
                        ),
                        link: ({ children, url }) => (
                          <Link to={url} className="text-footer underline">
                            {children}
                          </Link>
                        ),
                        image: ({ image }) => (
                          <img
                            src={image.url}
                            alt={image.alternativeText || ""}
                            className="img-100"
                          />
                        ),
                      }}
                    />
                    <br />
                  </Parallax>
                </div>
                <div className="right-text curve">
                  <Parallax speed={3}>
                    <div className="hovereffect">
                      <a className="test curve">
                        <img
                          src={`https://spagnoladmin.spagnolcompany.it${item.Image.data.attributes.url}`}
                        />
                      </a>
                    </div>
                  </Parallax>
                </div>
              </div>
            </div>
            <section className="middle-image brand" data-scroll-section>
              <Carousel
                showThumbs={false}
                showIndicators={false}
                emulateTouch={true}
                infiniteLoop={true}
                dynamicHeight={true}
              >
                {item.Images.data.map((item, index) => (
                  <img
                    key={index}
                    src={`https://spagnoladmin.spagnolcompany.it${item.attributes.url}`}
                  />
                ))}
              </Carousel>
            </section>
          </div>
        </Parallax>
      ))}
      <Popup products={selectedProducts.Popup} />
    </div>
  );
}
